import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { Row, Col, Table, Button, Modal, ButtonGroup, Card } from 'react-bootstrap';
import { BiListOl, BiRefresh, BiCamera, BiDownload } from 'react-icons/bi';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import '../../../shared/Shared.css';
import $ from 'jquery';
import 'react-toastify/dist/ReactToastify.css';
import swal from 'sweetalert';
import { VedikaService } from '../../../services/VedikaService';
import LoadingSpinner from '../../../shared/LoadingSpinner';

const Radiologi = () => {
    const [listRadiologi, setlistRadiologi] = useState([]);
    const [selectedData, setselectedData] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [detailHasilRad, setdetailHasilRad] = useState(null);

    const [showDeskripsi, setshowDeskripsi] = useState();
    const handleCloseDeskripsi = () => setshowDeskripsi(false);

    const loadInit = async () => {
        setIsLoading(true)
        try {
            // const promise1 = VedikaService.getRiwayatRadiologi(`NoCM=${$('#nocm').text()}`);
            const promise1 = await VedikaService.getRiwayatRadiologi(`noregistrasi=${$('#noRegistrasi').text()}`);
            const allPromise = await Promise.all([promise1]);
            setlistRadiologi(allPromise[0].data.daftar);
        } catch (error) {
            swal({
                title: error.code,
                text: error.message,
                icon: "error",
                button: "OK",
            })
                .then((val) => {
                });
        } finally {
            setIsLoading(false)
        }
    }
    const handleShowDeskripsi = (row) => {
        setshowDeskripsi(true);
        setselectedData(row)
        // loadDtDeskripsi(row)
        VedikaService.getHasilRadiologi(row.noorder, row.accession_num)
            .then((res) => {
                setdetailHasilRad(res.data.data)
            })
    }

    const handleHasil = (row) => {
        VedikaService.getAccNumberRadiologi(`noOrder=${row.noorder}&accession_num=${row.accession_num}`)
            .then((res) => {
                if (res.data.data.length > 0) {
                    openWindow(res.data.data[0].accession_num)
                } else {
                    alert('Hasil Tidak ada')
                }
            })
    }

    const openWindow = (accnum) => {
        const newWindow = window.open("", "_blank");
        if (newWindow) {
            newWindow.location.href = "http://pacs1.rsabhk.co.id:8080/URLCall.do?LID=dok&LPW=dok&LICD=003&PID=" + $('#nocm').text() + '&ACN=' + accnum;
        }
        // window.open("http://pacs1.rsabhk.co.id:8080/URLCall.do?LID=dok&LPW=dok&LICD=003&PID=" + $('#nocm').text() + '&ACN=' + accnum,"_blank", "noopener,noreferrer");
    }


    const loadDtRadiologi = (res) => {
        $('#dtRadiologi').DataTable({
            data: listRadiologi,
            ordering: false,
            pageLength: 10,
            scrollCollapse: true,
            scrollY: '50vh',
            destroy: true,
            autoWidth: false,
            columns: [
                {
                    targets: [0],
                    data: null,
                    width: '10%',
                    createdCell: (td, cellData, rowData, row, col) => createRoot(td).render(<div className='d-flex justify-content-center'><ButtonGroup aria-label="Basic example"><Button size='sm' variant="dark" data-bs-toggle="tooltip" data-bs-placement="right" title='Deskripsi' onClick={() => handleShowDeskripsi(rowData)}><BiListOl /></Button><Button size='sm' variant="dark" data-bs-toggle="tooltip" data-bs-placement="right" title='Hasil' onClick={() => handleHasil(rowData)}><BiCamera /></Button></ButtonGroup></div>),
                },
                {
                    targets: [1],
                    width: '10%',
                    data: 'noorder',
                },
                {
                    targets: [2],
                    width: '10%',
                    data: 'tglorder',
                },
                {
                    targets: [3],
                    width: '20%',
                    data: 'nama_layanan',
                },
                {
                    targets: [4],
                    width: '25%',
                    data: 'namaruanganasal',
                },
                {
                    targets: [5],
                    width: '25%',
                    // data: 'dokter',
                    data: null,
                    createdCell: (td, cellData, rowData, row, col) => createRoot(td).render(<span>{$('#dpjp').val()}</span>)
                },
            ]
        })
    }
    const loadDtDeskripsi = (res) => {
        setTimeout(() => {
            $('#dtDeskripsiRadiologi').DataTable({
                data: res.details,
                ordering: false,
                pageLength: 10,
                scrollCollapse: true,
                scrollY: '50vh',
                destroy: true,
                columns: [
                    {
                        targets: [0],
                        data: 'namaproduk',
                    },
                    {
                        targets: [1],
                        data: 'qtyproduk',
                    },
                ]
            })
        }, 2000);
    }

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            background: '#fff',
            borderColor: '#9e9e9e',
            minHeight: '30px',
            height: '30px',
            boxShadow: state.isFocused ? null : null,
        }),

        valueContainer: (provided, state) => ({
            ...provided,
            height: '30px',
            padding: '0 6px'
        }),

        input: (provided, state) => ({
            ...provided,
            margin: '0px',
        }),
        indicatorSeparator: state => ({
            display: 'none',
        }),
        indicatorsContainer: (provided, state) => ({
            ...provided,
            height: '30px',
        }),
    };

    useEffect(() => {
        loadDtRadiologi();
    }, [listRadiologi])

    useEffect(() => {
        setTimeout(() => {
            loadInit();
        }, 1000);
    }, [])

    return (
        <React.Fragment>
            {isLoading ? (<LoadingSpinner />) : null}
            <Row>
                <Col md={10} className='text-center bg-success text-white'>
                    <h5>Radiologi</h5>
                </Col>
                <Col className='d-flex justify-content-center bg-warning'>
                    <div className="d-flex flex-row-reverse align-items-center bd-highlight">
                        <a href={`https://pelayanan.rsabhk.co.id/vedika/cetak/radiologi/${$('#norec').val()}`} style={{ textDecoration: 'none', color: 'black' }} target='_blank' download><BiDownload /> Download </a>
                    </div>
                </Col>
                <Col className='d-flex justify-content-center bg-light'>
                    <div className="d-flex flex-row-reverse bd-highlight">
                        <Button size='sm' variant='light' onClick={loadInit}><BiRefresh /> Refresh</Button>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Table responsive="sm" size="sm" id='dtRadiologi' bordered hover style={{ fontSize: 'smaller' }}>
                        <thead>
                            <tr>
                                <th></th>
                                <th>No Order</th>
                                <th>Tgl Order</th>
                                <th>Nama Layanan</th>
                                <th>Ruangan Asal</th>
                                <th>DPJP</th>
                            </tr>
                        </thead>
                    </Table>
                </Col>
            </Row>
            <Modal
                show={showDeskripsi}
                onHide={handleCloseDeskripsi}
                backdrop="static"
                size='lg'
            >
                <Modal.Header closeButton>
                    <Modal.Title>Deskripsi</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* <Row>
                        <Table responsive="sm" size="sm" id='dtDeskripsiRadiologi' bordered hover style={{ fontSize: 'smaller' }}>
                            <thead>
                                <tr>
                                    <th>Deskripsi</th>
                                    <th>Qty</th>
                                </tr>
                            </thead>
                        </Table>
                    </Row> */}
                    {
                        detailHasilRad ?
                            (
                                <>
                                    <Card>
                                        <Card.Body>
                                            <Row>
                                                <Col md={4}>
                                                    {/* <p className='f7'><strong>DPJP</strong><br />{selectedData.dokter}</p> */}
                                                    <p className='f7'><strong>DPJP</strong><br />{$('#dpjp').val()}</p>
                                                </Col>
                                                <Col md={4}>
                                                    <p className='f7'><strong>Nama Layanan</strong><br />{selectedData.nama_layanan}</p>
                                                </Col>
                                                <Col md={4}>
                                                    <p className='f7'><strong>Tanggal Order</strong><br />{selectedData.tglorder}</p>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                    <Card className='mt-2'>
                                        <Card.Header>
                                            <h5>Detail</h5>
                                        </Card.Header>
                                        <Card.Body>
                                            <Row>
                                                {
                                                    Array.isArray(detailHasilRad.details) && detailHasilRad.details.length > 0 ? (
                                                        detailHasilRad.details.map((details) => (
                                                            <Col sm={12} key={details.report_key}>
                                                                <p className='f7'><strong>{details.conclusion}</strong> <hr className="hr" />{details.report_text}</p>
                                                            </Col>
                                                        ))
                                                    ) : (
                                                        <Col sm={12}>
                                                            <p className='f7 text-center'>Tidak ada detail hasil.</p>
                                                        </Col>
                                                    )
                                                }
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                </>
                            )
                            : null
                    }
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}

export default Radiologi;